//utils/uploadOss.ts
import OSS from "ali-oss";
import { getOssToken } from "@/api/oss";
import { useMainStore } from "@/store";
import { storeToRefs } from "pinia";
const ossInfo = "ossInfo";
const ossTimer = "ossTimer";

let ossData: any = "";
// 初始化OSS客户端,获取oss参数
export const initOSSClient = async (type: number) => {
  let sessionOssData = sessionStorage.getItem(ossInfo) || "";
  let sessionOssTimer: any = sessionStorage.getItem(ossTimer) || "";
  const currentTimerNow = Date.now();
  if (
    sessionOssData &&
    sessionOssTimer &&
    currentTimerNow - sessionOssTimer <= 40 * 60 * 1000
  ) {
    ossData = JSON.parse(sessionOssData);
  } else {
    const { data } = await getOssToken(type);
    sessionStorage.setItem(ossInfo, JSON.stringify(data));
    sessionStorage.setItem(ossTimer, Date.now() + "");
    ossData = data;
  }
  if (!ossData) return null; // 如果没有获取到OSS数据，则返回null
  console.log("ossData", ossData);
  ossData.region = ossData.region
    ? ossData.region
    : ossData.endpoint.split(".")[0];
  const client = new OSS({
    region: ossData.region, // 替换为你的OSS区域
    accessKeyId: ossData.accessKeyId,
    accessKeySecret: ossData.accessKeySecret,
    stsToken: ossData.securityToken,
    bucket: ossData.bucketName, // 替换为你的OSS Bucket名称
  });

  return client;
};

function getRandom() {
  const array = new Uint32Array(1);
  const crypto =
    (window as any).crypto ||
    (window as any).webkitCrypto ||
    (window as any).mozCrypto ||
    (window as any).oCrypto ||
    (window as any).msCrypto;
  const randomNum = crypto.getRandomValues(array)[0] / 0xffffffff;
  return randomNum;
}
// 生成随机文件名称
export const randomString = (e: any) => {
  e = e || 32;
  var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
    a = t.length,
    n = "";
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(getRandom() * a));
  return n;
};
// 上传文件到oss
export const uploadFileToOSS = async (
  targetDir: string,
  file: any,
  type: number,
  fileType: string = ""
) => {
  const ossClient: any = await initOSSClient(type);
  try {
    let filelink =
      dealUploadUrl(targetDir) + `${fileType ? "." + fileType : ""}`;
    const result = await ossClient.put(filelink, file, {
      headers: {
        "x-oss-forbid-overwrite": true, // 禁止覆盖同名文件
      },
    });
    console.log("上传成功", result);
    result.name = "/" + result.name;
    return result; // 返回上传后的文件URL
  } catch (err) {
    console.error("上传失败", err);
  }
};

export const getFormattedTime = (format: string) => {
  const now = new Date(); // 获取当前时间
  const year: any = now.getFullYear(); // 年
  const month = String(now.getMonth() + 1).padStart(2, "0"); // 月
  const day = String(now.getDate()).padStart(2, "0"); // 日
  const hours = String(now.getHours()).padStart(2, "0"); // 小时
  const minutes = String(now.getMinutes()).padStart(2, "0"); // 分钟
  const seconds = String(now.getSeconds()).padStart(2, "0"); // 秒

  // 根据传入的格式字符串动态拼接结果
  return format
    .replace("YYYY", year)
    .replace("MM", month)
    .replace("DD", day)
    .replace("HH", hours)
    .replace("MM", minutes)
    .replace("SS", seconds);
};

export const getFileExtension = (filename: string) => {
  // 使用正则表达式匹配文件扩展名
  const match = filename.match(/\.([^.]+)$/);
  if (match) {
    return match[1]; // 返回扩展名部分
  }
  return ""; // 如果没有匹配到扩展名，返回null
};

const dealUploadUrl = (fileName: string) => {
  const mainStore = useMainStore();
  const { pptId } = storeToRefs(mainStore);
  let ossCurrentDate = localStorage.getItem("ossCurrentDate") || "defaultDir";
  let date = ossCurrentDate;
  let url = ossData.prefix ? ossData.prefix + fileName : fileName;
  url +=
    "/" +
    date +
    "/" +
    pptId.value +
    "/" +
    getFormattedTime("YYYYMMDDHHMMSS") +
    randomString(4);
  return url;
};
